export const drawCirleChart = ($selectGauge: any, currentVal: number) => {
  var opts2 = {
    angle: 0,
    lineWidth: 0.2,
    radiusScale: 0.85,
    pointer: {
      length: 0.4,
      strokeWidth: 0.03,
      color: '#4a4a4a'
    },
    generateGradient: true,
    staticZones: [
      {
        strokeStyle: 'transparent',
        min: 0,
        max: 17,
        height: 0.6
      },
      {
        strokeStyle: 'transparent',
        min: 17,
        max: 34,
        height: 0.6
      },
      {
        strokeStyle: 'transparent',
        min: 34,
        max: 51,
        height: 0.6
      },
      {
        strokeStyle: 'transparent',
        min: 51,
        max: 68,
        height: 0.6
      },
      {
        strokeStyle: 'transparent',
        min: 68,
        max: 85,
        height: 0.6
      },
      {
        strokeStyle: 'transparent',
        min: 85,
        max: 100,
        height: 0.6
      },
    ],
    limitMax: false,
    limitMin: false,
    highDpiSupport: true
  };

  $selectGauge.minValue = 0;
  $selectGauge.maxValue = 100;
  $selectGauge.setOptions(opts2);
  $selectGauge.set(currentVal);
}

export const formatPercent = (per: number) => {
  if (per <= 0) {
    return 0;
  } else if (per >= 100) {
    return 100;
  } else {
    if (per < 50) {
      return Math.round(per * 15 / 49);
    } else if (per < 60) {
      return Math.round(((per - 50) * 15 / 9) + 17);
    } else if (per < 70) {
      return Math.round(((per - 60) * 15 / 9) + 34);
    } else if (per < 80) {
      return Math.round(((per - 70) * 15 / 9) + 51);
    } else if (per < 90) {
      return Math.round(((per - 80) * 15 / 9) + 68);
    } else {
      return Math.round(((per - 90) * 15 / 9) + 85);
    }
  }
}

export const gaugeOptions = {
  angle: 0,
  lineWidth: 0.2,
  radiusScale: 0.85,
  pointer: {
    length: 0.4,
    strokeWidth: 0.03,
    color: '#4a4a4a'
  },
  generateGradient: true,
  staticZones: [
    {
      strokeStyle: 'transparent',
      min: 0,
      max: 17,
      height: 0.6
    },
    {
      strokeStyle: 'transparent',
      min: 17,
      max: 34,
      height: 0.6
    },
    {
      strokeStyle: 'transparent',
      min: 34,
      max: 51,
      height: 0.6
    },
    {
      strokeStyle: 'transparent',
      min: 51,
      max: 68,
      height: 0.6
    },
    {
      strokeStyle: 'transparent',
      min: 68,
      max: 85,
      height: 0.6
    },
    {
      strokeStyle: 'transparent',
      min: 85,
      max: 100,
      height: 0.6
    },
  ],
  limitMax: false,
  limitMin: false,
  highDpiSupport: true
}
